import { SCREENS } from "utils/constants";
import Detail from "./Detail";

const routes = [
  {
    path: `${SCREENS.PUBLIC.QUOTES.DETAIL.path}/:id`,
    exact: true,
    element: <Detail />,
  },
];

export default routes;
